/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react'
import * as Yup from 'yup'
import clsx from 'clsx'
import { useFormik } from 'formik'
import { useAuth } from '../../../contexts/AuthProvider'
import { Link, useHistory } from 'react-router-dom'
import { useEffect } from 'react';
/*Tradução */
import '../../../../i18n/config';
import { useTranslation } from 'react-i18next';
import i18next from 'i18next';
import { CHAVE_MOTIVO_LOGOUT, CODIGO_USUARIO_INATIVO } from '../../../services/Api';


export function Login() {
  const [loading, setLoading] = useState(false)
  const { signIn } = useAuth();
  const history = useHistory();
  const { t } = useTranslation();
  const { i18n } = useTranslation();
  const changeLanguage = (lng: string) => {
    localStorage.setItem("idioma-selecionado", lng)
    i18next.changeLanguage(lng);
    i18n.changeLanguage(lng);
  };
  const loginSchema = Yup.object().shape({
    email: Yup.string()
      .email(t('Email incorreto'))
      .min(3, t('Minimo 3 caracteres'))
      .max(50, t('Máximo 50 caracteres'))
      .required(t('Email é obrigatório')),
    password: Yup.string()
      .min(3, t('Minimo 3 caracteres'))
      .max(50, t('Máximo 50 caracteres'))
      .required(t('Senha é obrigatório')),
  })
  const initialValues = {
    email: '',
    password: ''
  }

  /*
    Formik+YUP+Typescript:
    https://jaredpalmer.com/formik/docs/tutorial#getfieldprops
    https://medium.com/@maurice.de.beijer/yup-validation-and-typescript-and-formik-6c342578a20e
  */
  const formik = useFormik({
    initialValues,
    validationSchema: loginSchema,
    onSubmit: (values, { setStatus, setSubmitting }) => {
      setLoading(true)
      signIn(values.email, values.password)
        .then((result: any) => {
          if (result?.mustChangePassword) {
            history.push('/definir-senha')
          }
        })
        .catch((error: any) => {
          setLoading(false)
          setSubmitting(false)
          const is401 = error?.response?.status === 401;
          const data = error?.response?.data;
          if (is401 && data?.codigo === CODIGO_USUARIO_INATIVO) {
            // DEVN3-780: credencial certa, usuário inativo — não confundir com senha errada.
            try { sessionStorage.removeItem(CHAVE_MOTIVO_LOGOUT) } catch { /* sem storage */ }
            setStatus(data.message)
            return
          }
          setStatus(is401 ? "Email ou senha estão incorretos." : "Ocorreu um erro inesperado, por favor tente novamente.")
        })
    },
  })

  // DEVN3-780: sessão derrubada porque o usuário foi inativado — mostra o motivo uma vez.
  useEffect(() => {
    let motivo: string | null = null
    try {
      motivo = sessionStorage.getItem(CHAVE_MOTIVO_LOGOUT)
      sessionStorage.removeItem(CHAVE_MOTIVO_LOGOUT)
    } catch { /* sem storage */ }
    if (motivo) formik.setStatus(motivo)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <form
      className='form w-100'
      onSubmit={formik.handleSubmit}
      noValidate
      id='kt_login_signin_form'
    >
      {formik.status && (
        <div className='mb-lg-15 alert alert-danger'>
          <div className='alert-text font-weight-bold'>{formik.status}</div>
        </div>
      )}

      {/* begin::Form group */}
      <div className='fv-row mb-10'>
        <label className='form-label fs-6 fw-bolder text-dark'>{t('Usuário')}</label>
        <input
          placeholder='Email'
          {...formik.getFieldProps('email')}
          className={clsx(
            'form-control form-control-lg form-control-solid',
            { 'is-invalid': formik.touched.email && formik.errors.email },
            {
              'is-valid': formik.touched.email && !formik.errors.email,
            }
          )}
          type='email'
          name='email'
          autoComplete='off'
        />
        {formik.touched.email && formik.errors.email && (
          <div className='fv-plugins-message-container'>
            <span role='alert'>{formik.errors.email}</span>
          </div>
        )}
      </div>
      {/* end::Form group */}

      {/* begin::Form group */}
      <div className='fv-row mb-5'>
        <div className='d-flex justify-content-between mt-n5'>
          <div className='d-flex flex-stack mb-2'>
            {/* begin::Label */}
            <label className='form-label fw-bolder text-dark fs-6 mb-0'>{t('Senha')}</label>
            {/* end::Label */}
            {/* begin::Link */}
            {/* end::Link */}
          </div>
        </div>
        <input
          placeholder={t('Senha')}
          type='password'
          autoComplete='off'
          {...formik.getFieldProps('password')}
          className={clsx(
            'form-control form-control-lg form-control-solid',
            {
              'is-invalid': formik.touched.password && formik.errors.password,
            },
            {
              'is-valid': formik.touched.password && !formik.errors.password,
            }
          )}
        />
        {formik.touched.password && formik.errors.password && (
          <div className='fv-plugins-message-container'>
            <div className='fv-help-block'>
              <span role='alert'>{formik.errors.password}</span>
            </div>
          </div>
        )}
      </div>
      {/* end::Form group */}
      <div className='fv-row mb-5'>
        <Link
          to='/esqueci-minha-senha'
          className='link-primary fs-6 fw-bolder'
          style={{ marginLeft: '5px', textAlign: 'right', width: '100%' }}
        >
          {t("Esqueci minha senha")}
        </Link>
      </div>
      {/* begin::Action */}
      <div className='text-center'>
        <button
          type='submit'
          id='kt_sign_in_submit'
          className='btn btn-lg btn-primario w-100 mb-5'
          disabled={formik.isSubmitting || !formik.isValid}
        >
          {!loading && <span className='indicator-label'>{t('ENTRAR')}</span>}
          {loading && (
            <span className='indicator-progress' style={{ display: 'block' }}>
              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
              {t("Aguarde...")}
            </span>
          )}
        </button>
      </div>
      <div className='traducao'>
        <div
          className={`btn-traducao ${i18n.language !== "en" ? "btn-traducao-selected" : ""}`}
          onClick={() => changeLanguage("en")}>
          <img className='flags' src="/media/icons/duotone/Flags/en.png" alt="English" />
        </div>
        <div
          className={`btn-traducao ${i18n.language !== "br" ? "btn-traducao-selected" : ""}`}
          onClick={() => changeLanguage("br")}>
          <img className='flags' src="/media/icons/duotone/Flags/br.png" alt="Português" />
        </div>
        <div
          className={`btn-traducao ${i18n.language !== "es" ? "btn-traducao-selected" : ""}`}
          onClick={() => changeLanguage("es")}>
          <img className='flags' src="/media/icons/duotone/Flags/es.png" alt="Español" />
        </div>
        <div
          className={`btn-traducao ${i18n.language !== "ca" ? "btn-traducao-selected" : ""}`}
          onClick={() => changeLanguage("ca")}>
          <img className='flags' src="/media/icons/duotone/Flags/ca.png" alt="Català" />
        </div>
      </div>
      {/* end::Action */}
    </form>
  )
}
